import React from 'react';
import { RiskScoreColour } from 'src/shared/components/risk-score-cell/riskScoreColour';

const NODGE_CLASS: Record<RiskScoreColour, string> = {
    'divergent-red-amber-green-1': 'bg-divergent-red-amber-green-1',
    'divergent-red-amber-green-2': 'bg-divergent-red-amber-green-2',
    'divergent-red-amber-green-3': 'bg-divergent-red-amber-green-3',
    'divergent-red-amber-green-4': 'bg-divergent-red-amber-green-4',
    'divergent-red-amber-green-5': 'bg-divergent-red-amber-green-5',
};

export type RichFilterCheckboxProps = {
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    colour?: RiskScoreColour;
    line2?: string;
};

const RichFilterCheckbox = ({ label, checked, onChange, colour, line2 }: RichFilterCheckboxProps) => (
    <label className='flex flex-row gap-2 px-3 py-2 bg-white border border-[#DEDEDE] rounded-[10px] cursor-pointer'>
        <div className='flex flex-col justify-center flex-1'>
            <div className='flex flex-row items-center gap-2'>
                {colour && (
                    <span
                        aria-hidden='true'
                        data-testid='rich-filter-checkbox-nodge'
                        className={`w-3 h-3 rounded-full shrink-0 ${NODGE_CLASS[colour]}`}
                    />
                )}
                <span className='text-sm text-black'>{label}</span>
            </div>
            {line2 && (
                <span data-testid='rich-filter-checkbox-line2' className='text-xs leading-4 text-grey-80'>
                    {line2}
                </span>
            )}
        </div>
        <input type='checkbox' checked={checked} onChange={e => onChange(e.target.checked)} className='mt-[2.5px]' />
    </label>
);

export default RichFilterCheckbox;
